<script>
  export let text = null;
</script>

{#if text}
  <div class="loader">
    <div class="bg"></div>
    <div class="indicator">
      <div class="pong-loader"></div>
      <div class="text">{text}</div>
    </div>
  </div>
{/if}

<style>
  .loader {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 100;
  }
  .bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 1;
      background-color: #252525;
      opacity: 0.9;
  }
  .indicator {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      z-index: 2;
  }
  .text, .pong-loader {
      color: white;
      z-index: 2;
  }
</style>